import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserService } from '@app/core/store/user.service';
import { ConfigService } from '@infomaniak/angular-common';
import {
  IIkSelectPaymentBillingAddress,
  IIkSelectPaymentChangeBillingAddressModalData,
  IIkSelectPaymentChangeMethodEditModalData,
  IIkSelectPaymentMethodsIcons,
  IIkSelectPaymentPaiementProfileCard,
  IIkSelectPaymentPaiementProfilePrepaid,
  IIkSelectPaymentReadModalData,
} from '../../invitation-b2b-client.interfaces';
import { InvitationB2bClientService } from '../../invitation-b2b-client.service';
import { IkSelectPaymentChangeBillingAddressEditModalComponent } from './modals/change-biilling-address-edit-modal/ik-select-payment-change-biilling-address-edit-modal.component';
import { IkSelectPaymentChangeBillingAddressReadModalComponent } from './modals/change-biilling-address-read-modal/ik-select-payment-change-biilling-address-read-modal.component';
import { IkSelectPaymentChangeProfileEditModalComponent } from './modals/change-method-edit-modal/ik-select-payment-change-profile-edit-modal.component';
import { IkSelectPaymentChangeProfileReadModalComponent } from './modals/change-method-read-modal/ik-select-payment-change-profile-read-modal.component';

@Component({
  selector: 'app-invitation-b2b-client-payment-infos',
  templateUrl: './invitation-b2b-client-payment-infos.component.html',
  styleUrls: ['./invitation-b2b-client-payment-infos.component.scss'],
})
export class InvitationB2bClientPaymentInfosComponent implements OnInit {
  @Input() iconsMethod: IIkSelectPaymentMethodsIcons;
  @Input() onlyView = false;
  @Input() selectedAccount: any;

  paiementProfiles: Array<IIkSelectPaymentPaiementProfileCard | IIkSelectPaymentPaiementProfilePrepaid> = null;
  defaultPaiementProfile: IIkSelectPaymentPaiementProfileCard | IIkSelectPaymentPaiementProfilePrepaid = null;
  billingAddresses: IIkSelectPaymentBillingAddress[] = [];
  defaultBillingAddress: IIkSelectPaymentBillingAddress = null;
  loadingPaymentProfile = true;
  loadingAddress = true;

  // protected accountId = this.userService.getCurrentGroup().id;

  constructor(
    protected userService: UserService,
    protected configService: ConfigService,
    private invitationB2bClientService: InvitationB2bClientService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.onlyView = true;
    this.invitationB2bClientService
      .getPaiementProfile(this.selectedAccount.id)
      .then((data) => {
        this.paiementProfiles = data.map((item) => ({
          ...item,
          iconUrl:
            item.details_type === 'card'
              ? this.getCardIcon(item.details.payment_method)
              : 'assets/images/payment/prepaid_account.svg',
        }));

        this.defaultPaiementProfile = this.paiementProfiles.find((item) => item.default) ?? null;
      })
      .catch((err) => {
        // this.configService.displayErrors(err);
        // silent error as it is only display
      })
      .finally(() => {
        this.loadingPaymentProfile = false;
      });

    this.invitationB2bClientService
      .getBillingAdresses(this.selectedAccount.id)
      .then((addresses) => {
        this.billingAddresses = addresses;
        this.defaultBillingAddress = addresses.find((item) => item.default) ?? null;
      })
      .catch((err) => {
        // this.configService.displayErrors(err);
        // silent error as it is only display
      })
      .finally(() => {
        this.loadingAddress = false;
      });
  }

  viewMoreMethod(): void {
    const dialogConfig: MatDialogConfig<IIkSelectPaymentReadModalData> = {
      width: '600px',
      data: {
        defaultBillingAddress: this.defaultBillingAddress,
        defaultPaiementProfile: this.defaultPaiementProfile,
        selectedAccount: this.selectedAccount,
      },
    };

    this.dialog.open(IkSelectPaymentChangeProfileReadModalComponent, dialogConfig);
  }

  viewMoreBilling(): void {
    const dialogConfig: MatDialogConfig<IIkSelectPaymentReadModalData> = {
      width: '600px',
      data: {
        defaultBillingAddress: this.defaultBillingAddress,
        defaultPaiementProfile: this.defaultPaiementProfile,
        selectedAccount: this.selectedAccount,
      },
    };

    this.dialog.open(IkSelectPaymentChangeBillingAddressReadModalComponent, dialogConfig);
  }

  changeBillingAddress(): void {
    const dialogConfig: MatDialogConfig<IIkSelectPaymentChangeBillingAddressModalData> = {
      width: '600px',
      data: {
        billingAddresses: this.billingAddresses,
      },
    };

    this.dialog.open(IkSelectPaymentChangeBillingAddressEditModalComponent, dialogConfig);
  }

  changePaymentMethod(): void {
    const dialogConfig: MatDialogConfig<IIkSelectPaymentChangeMethodEditModalData> = {
      width: '600px',
      data: {
        paiementProfiles: this.paiementProfiles,
      },
    };

    this.dialog.open(IkSelectPaymentChangeProfileEditModalComponent, dialogConfig);
  }

  getCardIcon(card: string): string {
    switch (card) {
      case 'Visa':
        return 'assets/images/payment/cards/vignette_visa.svg';

      case 'Mastercard':
        return 'assets/images/payment/cards/vignette_masterca.svg';

      case 'American express':
        return 'assets/images/payment/cards/vignette_amex.svg';

      default:
        return 'assets/images/payment/cards/vignette_cb.svg';
    }
  }
}
